<div class="surface-card" *ngIf="seahorseModule">
  <div class="surface-card-header">
    {{ 'seahorseModules.seahorseModule' | translate }}
  </div>
  <div class="surface-card-body setting-list">
    <div class="setting-group">
      <div class="setting-row">
        <sh-toggle
          [value]="seahorseModule.isActive"
          [disabled]="saving"
          ariaLabel="customUI.memberModel.isActive"
          (valueChange)="setActive($event)"
        ></sh-toggle>
        <div class="setting-text">
          <div class="setting-name">
            {{ 'customUI.memberModel.isActive' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
